export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  multFieldInline: {
    width: '100%',
    display: 'flex',
  },

  datePickerField: {
    '& .MuiInputBase-input': {
      color: `${theme.custom.colors.text} !Important`,
    },

    '& .MuiInputLabel-root': {
      color: `${theme.custom.colors.text} !important`,
    },

    '& .MuiInputLabelRoot.Mui-focused': {
      color: `${theme.custom.colors.text} !important`,
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: `${theme.custom.colors.text} !important`,
      },
      '&:hover fieldset': {
        borderColor: `${theme.custom.colors.text} !important`,
      },
      '&.MuiFocused fieldset': {
        borderColor: `${theme.custom.colors.text} !important`,
      },
    },

    '& .MuiSvgIcon-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },

  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: 'solid grey 2px',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
  },

  menuProps: {
    PaperProps: {
      sx: {
        backgroundColor: theme.custom.colors.defaultBackground,
        color: theme.custom.colors.text,
      },
    },
  },

  tab: {
    color: `${theme.custom.colors.text} !important`,
    backgroundColor: theme.custom.colors.defaultBackground,

    '& .MuiTab-root': {
      color: '#999999',
    },
    '& .Mui-selected': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${theme.custom.colors.text} !important`,
    },
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  tokenRefresh: {
    minWidth: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
